module.exports = __webpack_public_path__ + "static/media/attendanceReport.bf7b0589.svg";